<template>
  <div id="clouds">
    <svg
      class="cloud"
      v-for="(style, i) in cloudStyles"
      :class="getClass(i)"
      :style="style"
      :key="i"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
    >
      <path
        d="m391.84 540.91c-.421-.329-.949-.524-1.523-.524-1.351 0-2.451 1.084-2.485 2.435-1.395.526-2.388 1.88-2.388 3.466 0 1.874 1.385 3.423 3.182 3.667v.034h12.73v-.006c1.775-.104 3.182-1.584 3.182-3.395 0-1.747-1.309-3.186-2.994-3.379.007-.106.011-.214.011-.322 0-2.707-2.271-4.901-5.072-4.901-2.073 0-3.856 1.202-4.643 2.925"
        transform="matrix(.77976 0 0 .78395-299.99-418.63)"
      />
    </svg>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  methods: {
    getClass(i) {
      return i % 2 || 'mirrored'
    }
  },
  computed: {
    cloudStyles() {
      const result = []
      const amount = 6
      for (let i = 1; i <= amount + 1; i++) {
        result.push({
          animationDuration: _.random(300, 400) + 's',
          animationDelay: i * 60 * -1 + 's',
          top: ((i - 1) / amount) * 80 + '%',
          height: _.random(6, 10) + 'em'
        })
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
#clouds {
  background-color: rgba(var(--color-subtle), 1);
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  margin: auto;
  height: 100%;
  overflow: hidden;
  -webkit-animation: FadeIn 0.3s ease-out;
  animation: FadeIn 0.3s ease-out;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
@-webkit-keyframes FadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes FadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.cloud {
  width: 100%;
  height: 70px;
  position: absolute;
  -webkit-animation-duration: 120s;
  animation-duration: 120s;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
  -webkit-animation-name: Float, FadeFloat;
  animation-name: Float, FadeFloat;
  &.mirrored {
    -webkit-animation-name: FloatMirrored, FadeFloat;
    animation-name: FloatMirrored, FadeFloat;
  }
  z-index: 1;
  fill: color(white);
}
$x: 70;
@-webkit-keyframes Float {
  from {
    -webkit-transform: translateX($x * 1%) translateZ(0);
    transform: translateX($x * 1%) translateZ(0);
  }
  to {
    -webkit-transform: translateX($x * -1%) translateZ(0);
    transform: translateX($x * -1%) translateZ(0);
  }
}
@keyframes Float {
  from {
    -webkit-transform: translateX($x * 1%) translateZ(0);
    transform: translateX($x * 1%) translateZ(0);
  }
  to {
    -webkit-transform: translateX($x * -1%) translateZ(0);
    transform: translateX($x * -1%) translateZ(0);
  }
}
@-webkit-keyframes FloatMirrored {
  from {
    -webkit-transform: translateX($x * 1%) translateZ(0) scale(-1, 1);
    transform: translateX($x * 1%) translateZ(0) scale(-1, 1);
  }
  to {
    -webkit-transform: translateX($x * -1%) translateZ(0) scale(-1, 1);
    transform: translateX($x * -1%) translateZ(0) scale(-1, 1);
  }
}
@keyframes FloatMirrored {
  from {
    -webkit-transform: translateX($x * 1%) translateZ(0) scale(-1, 1);
    transform: translateX($x * 1%) translateZ(0) scale(-1, 1);
  }
  to {
    -webkit-transform: translateX($x * -1%) translateZ(0) scale(-1, 1);
    transform: translateX($x * -1%) translateZ(0) scale(-1, 1);
  }
}
/*
  @keyframes Float {
    from { transform: translateX(100%) translateY(-100%) translateZ(0); }
    50% { transform: translateX(55%) translateY(0) translateZ(0); }
    to { transform: translateX(-5%) translateY(-100%) translateZ(0); }
  }
  */
@-webkit-keyframes FadeFloat {
  0%,
  100% {
    opacity: 0;
  }
  5%,
  90% {
    opacity: 1;
  }
}
@keyframes FadeFloat {
  0%,
  100% {
    opacity: 0;
  }
  5%,
  90% {
    opacity: 1;
  }
}
</style>
